module.exports = __webpack_public_path__ + "static/media/story_bg.215b64e1.png";